import React from 'react'
import config from 'config'

const {
  legal: { terms_conditions },
} = config
const currentYear = new Date().getFullYear()

const PDFLink = ({ to, name }) => (
  <a
    href={to}
    className="block secondary-text text-white opacity-30 hover:text-white hover:opacity-100 mb-1"
    target="_blank"
    rel="noreferrer"
  >
    {name}
  </a>
)

const CopyRight = () => (
  <div className="text-white">
    <div className="secondary-text mb-1 opacity-60">© Teleport {currentYear}</div>
    <PDFLink
      to={terms_conditions}
      className="secondary-text text-white opacity-30 hover:text-white hover:opacity-100"
      name="All rights reserved."
    />
  </div>
)

export default CopyRight
